import templateUrl from "emun.products/picker/product-picker-import-items.htm";
import ProductPickerImportItemsController from "emun.products/picker/product-picker-import-items.controller";
import open from "webmodals/open";

let ProductPickerImportItems = options => {
  let modalInstance = open({
    size: options.size || "lg",
    templateUrl: options.templateUrl || templateUrl,
    controller: ProductPickerImportItemsController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default ProductPickerImportItems;
